import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_BILLING_CODE_ODOO_LOADING = 'GET_BILLING_CODE_ODOO_LOADING';
export const GET_BILLING_CODE_ODOO_SUCCESS = 'GET_BILLING_CODE_ODOO_SUCCESS';
export const GET_BILLING_CODE_ODOO_REJECT = 'GET_BILLING_CODE_ODOO_REJECT';

//* ACTIONS ------------------------------------------------
export const getBillingCodeOdooLoading = () => ({ type: GET_BILLING_CODE_ODOO_LOADING });
export const getBillingCodeOdooSuccess = (payload) => ({ type: GET_BILLING_CODE_ODOO_SUCCESS, payload });
export const getBillingCodeOdooReject = (payload) => ({ type: GET_BILLING_CODE_ODOO_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getBillingCodeOdooRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/BillingCode/web/GetBillingCodeOdoo`, options);
};
